import { createFileRoute } from '@tanstack/react-router';

import { CreatePost } from '#modules/finder/features/posts/components/CreatePost';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/discover/create'
)({
  component: CreatePost,
  ssr: false,
});
